export const IS_TESTING = false;
export const HEADER_HEIGHT = 64;
